import { useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import useMainStore from '../store/mainState';

const useLogout = () => {
    const apolloClient = useApolloClient();
    const navigate = useNavigate();
    const { setUser, setIsCollapsed } = useMainStore();

    return async () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
        setUser(null);
        await apolloClient.resetStore();
        if (window.innerWidth < 768) setIsCollapsed(true);
        navigate('/');
    };
};

export default useLogout;
